import { render } from "./IconPdfExam.vue?vue&type=template&id=5c71c2f3"
import script from "./IconPdfExam.vue?vue&type=script&lang=js"
export * from "./IconPdfExam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__